/* L'ORDRE — JS léger, sans dépendance. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var currency = window.themeMoney || 'CHF';
  var fmt;
  try { fmt = new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: currency }); } catch (e) { fmt = null; }
  function money(cents) { return fmt ? fmt.format(cents / 100) : (cents / 100).toFixed(2) + ' ' + currency; }

  /* ---------- Tiroir panier ---------- */
  var drawer = $('#cart-drawer');
  function openDrawer() { if (!drawer) return; drawer.classList.add('is-open'); drawer.removeAttribute('aria-hidden'); var c = $('[data-drawer-close]', drawer); if (c) c.focus(); }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); }
  function refreshCart() {
    return fetch(window.routes.root + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (data) {
      var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      var fresh = $('#cart-drawer-content', doc), cur = $('#cart-drawer-content');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      showInAppNotice();
    }).then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); }).then(function (cart) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    });
  }
  function addItems(items, msgEl) {
    if (msgEl) msgEl.textContent = '';
    return fetch(window.routes.cart_add, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { if (msgEl) msgEl.textContent = res.j.description || res.j.message || 'Impossible d’ajouter cet article.'; return false; }
        return refreshCart().then(function () { openDrawer(); return true; });
      });
  }
  function showInAppNotice() {
    var ua = navigator.userAgent || '';
    if (/TikTok|musical_ly|BytedanceWebview|Instagram|FBAN|FBAV/i.test(ua)) { $$('[data-inapp-notice]').forEach(function (n) { n.hidden = false; }); }
  }

  /* ---------- Sélecteur de variante ---------- */
  function initRoot(root) {
    var jsonEl = $('[data-product-json]', root); if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var hidden = $('[data-variant-id]', root), priceEl = $('[data-price]', root), btn = $('[data-add]', root);
    function selected() {
      return $$('[data-option-index]', root).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
    }
    function update() {
      var sel = selected();
      var v = $$('[data-option-index]', root).length ? product.variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0] : product.variants[0];
      root._variant = v;
      var sec = root.closest('[data-product-section]');
      if (sec) { $$('input[name="id"]', sec).forEach(function (i) { i.value = v ? v.id : ''; }); }
      if (hidden) hidden.value = v ? v.id : '';
      if (priceEl) {
        priceEl.innerHTML = v ? (v.compare_at_price && v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '') + money(v.price) : '';
        if (v && v.compare_at_price && v.compare_at_price > v.price) { priceEl.innerHTML = money(v.price) + ' <s>' + money(v.compare_at_price) + '</s>'; }
      }
      if (btn) {
        var ok = v && v.available;
        btn.disabled = !ok;
        btn.textContent = !v ? 'Indisponible' : (ok ? (btn.getAttribute('data-label') || 'Ajouter au panier') : 'Épuisé');
      }
      // grise les options épuisées selon les autres choix
      $$('[data-option-index]', root).forEach(function (fs, idx) {
        $$('input', fs).forEach(function (inp) {
          var test = sel.slice(); test[idx] = inp.value;
          var any = product.variants.some(function (x) { return x.available && x.options.every(function (o, i) { return o === test[i]; }); });
          inp.setAttribute('data-soldout', any ? 'false' : 'true');
        });
      });
      if (v && root.hasAttribute('data-sync-url') && window.history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u);
      }
    }
    root.addEventListener('change', function () { update(); root.dispatchEvent(new CustomEvent('variantchange', { bubbles: true })); });
    update();
  }
  $$('[data-product-root]').forEach(initRoot);
  $$('[data-bundle]').forEach(function (b) {
    var tot = $('[data-bundle-total]', b);
    function sum() { var t = 0; $$('[data-product-root]', b).forEach(function (r) { if (r._variant) t += r._variant.price; }); if (tot) tot.textContent = money(t); }
    b.addEventListener('variantchange', sum); sum();
  });

  /* ---------- Clics délégués ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var el;
    if ((el = t.closest('[data-drawer-open]'))) { e.preventDefault(); refreshCart().then(openDrawer); return; }
    if (t.closest('[data-drawer-close]') || t.closest('.drawer__scrim')) { closeDrawer(); return; }
    if ((el = t.closest('[data-add]'))) {
      var root = el.closest('[data-product-root]'); if (!root) return;
      e.preventDefault();
      var id = parseInt($('[data-variant-id]', root).value, 10); if (!id) return;
      var msg = $('[data-msg]', root);
      el.disabled = true;
      addItems([{ id: id, quantity: 1 }], msg).then(function () { el.disabled = false; });
      return;
    }
    if ((el = t.closest('[data-bundle-add]'))) {
      e.preventDefault();
      var wrap = el.closest('[data-bundle]');
      var items = $$('[data-product-root]', wrap).map(function (r) { return { id: parseInt($('[data-variant-id]', r).value, 10), quantity: 1 }; }).filter(function (i) { return i.id; });
      if (!items.length) return;
      el.disabled = true;
      addItems(items, $('[data-msg]', wrap)).then(function () { el.disabled = false; });
      return;
    }
    if ((el = t.closest('[data-line-qty]'))) {
      e.preventDefault();
      fetch(window.routes.cart_change, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: parseInt(el.getAttribute('data-line'), 10), quantity: parseInt(el.getAttribute('data-line-qty'), 10) }) }).then(refreshCart).then(function () { if (document.body.classList.contains('template-cart')) window.location.reload(); });
      return;
    }
    if ((el = t.closest('[data-hero-thumb]'))) {
      var i = el.getAttribute('data-hero-thumb'), hero = el.closest('[data-hero]');
      $$('[data-hero-thumb]', hero).forEach(function (b) { b.setAttribute('aria-current', b === el ? 'true' : 'false'); });
      $$('[data-hero-panel]', hero).forEach(function (p) { p.hidden = p.getAttribute('data-hero-panel') !== i; });
      $$('[data-hero-image]', hero).forEach(function (im) { im.hidden = im.getAttribute('data-hero-image') !== i; });
      return;
    }
    if ((el = t.closest('[data-gallery-thumb]'))) {
      var main = $('[data-gallery-main] img'); if (!main) return;
      main.src = el.getAttribute('data-src'); main.setAttribute('data-large', el.getAttribute('data-large') || el.getAttribute('data-src')); main.srcset = el.getAttribute('data-srcset') || ''; main.alt = el.getAttribute('data-alt') || '';
      $$('[data-gallery-thumb]').forEach(function (b) { b.setAttribute('aria-current', b === el ? 'true' : 'false'); });
      return;
    }
    if (t.closest('[data-gallery-main]')) {
      var dlg = $('[data-lightbox]'), im = $('[data-gallery-main] img');
      if (dlg && im && dlg.showModal) { $('img', dlg).src = im.getAttribute('data-large') || im.src; dlg.showModal(); }
      return;
    }
    if (t.closest('[data-lightbox-close]')) { var d = $('[data-lightbox]'); if (d) d.close(); return; }
    if (t.closest('[data-menu-open]')) { var m = $('[data-menu-panel]'); if (m) m.classList.add('is-open'); return; }
    if (t.closest('[data-menu-close]')) { var m2 = $('[data-menu-panel]'); if (m2) m2.classList.remove('is-open'); return; }
    if ((el = t.closest('[data-sticky-add]'))) { var main2 = $('.pdp__info [data-add]'); if (main2) main2.click(); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* Filtres de collection : envoi auto */
  $$('[data-filter-form]').forEach(function (f) { f.addEventListener('change', function () { f.submit(); }); });

  /* ---------- Barre d'achat collante (mobile) ---------- */
  var mainBtn = $('.pdp__info [data-add]'), sticky = $('.sticky-atc');
  if (mainBtn && sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(mainBtn);
  }

  /* ---------- Recommandations (« Complète le look ») ---------- */
  $$('[data-recommendations]').forEach(function (box) {
    fetch(box.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html'), c = $('[data-recs-content]', doc);
      if (c && c.children.length) { box.innerHTML = c.innerHTML; box.removeAttribute('hidden'); }
    }).catch(function () {});
  });

  /* ---------- En-tête transparent puis plein ---------- */
  var hdr = $('.site-header');
  if (hdr) { var onScroll = function () { hdr.classList.toggle('is-solid', window.scrollY > 40); }; onScroll(); window.addEventListener('scroll', onScroll, { passive: true }); }

  /* ---------- Bandeau d'avis : pause / lecture ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rv-toggle]'); if (!b) return;
    var m = $('[data-rv-marquee]', b.closest('.rv')); if (!m) return;
    var paused = m.classList.toggle('is-paused');
    b.setAttribute('aria-pressed', paused ? 'true' : 'false');
    b.textContent = paused ? '[ Lecture ]' : '[ Pause ]';
  });

  /* ---------- Sliders ---------- */
  document.addEventListener('click', function (e) {
    var n = e.target.closest('[data-slider-next],[data-slider-prev]'); if (!n) return;
    var track = $('[data-slider]', n.closest('.pitch__slider') || document); if (!track) return;
    track.scrollBy({ left: (n.hasAttribute('data-slider-next') ? 1 : -1) * track.clientWidth * 0.8, behavior: 'smooth' });
  });

  /* ---------- Révélations au défilement ---------- */
  var reveals = $$('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { threshold: 0.12 });
    reveals.forEach(function (n) { io.observe(n); });
  } else { reveals.forEach(function (n) { n.classList.add('is-in'); }); }

  showInAppNotice();
})();
